<template>
  <div class="column">
    <div
      v-for="(value, index) in dataList"
      :key="index"
    >
      {{ formatFnc(value) || value || $t('emptyValue') }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    formatFnc: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.column {
  white-space: nowrap;
}
</style>
